import React, { FC } from 'react'
import {
  FilterMultiSelect,
  IFilterMultiSelectOption,
} from 'transfix-ui/components/FilterMultiSelect'
import { FilterIcon } from 'transfix-icons'

interface IStatusFilterProps {
  statuses?: string[]
  onSelect: (statuses: string[]) => void
}

const statusOptionDefaults: IFilterMultiSelectOption[] = [
  {
    label: 'Complete',
    value: 'success',
    selected: false,
  },
  {
    label: 'In Progress',
    value: 'pending',
    selected: false,
  },
  {
    label: 'Error',
    value: 'error',
    selected: false,
  },
  {
    label: 'Failure',
    value: 'failure',
    selected: false,
  },
]

export const StatusFilter: FC<IStatusFilterProps> = ({
  statuses = [],
  onSelect,
}: IStatusFilterProps) => {
  const statusOptions = statusOptionDefaults.map(statusOption => ({
    ...statusOption,
    selected: statuses.length === 0 || statuses.includes(statusOption.value),
  }))
  const onSelectChange = (options?: IFilterMultiSelectOption[]) => {
    const selectedStatuses = options?.filter(opt => !!opt.selected).map(opt => opt.value) || []
    onSelect(selectedStatuses)
  }

  return (
    <FilterMultiSelect
      id='status-filter'
      label='Status'
      options={statusOptions}
      onSelect={onSelectChange}
      icon={<FilterIcon className='mt1' size='large' />}
      dataTest='status-filter'
    />
  )
}
